/*
 * ROMANTICO - Dropdown-list size selector
 * Thin controller around a native radio group inside Dawn's <variant-selects>.
 * The radios still drive variant selection; this only opens/closes the panel
 * and mirrors the chosen size into the closed trigger. Closes on selection,
 * outside click, and Escape.
 */
if (!customElements.get('rom-size-select')) {
  customElements.define(
    'rom-size-select',
    class RomSizeSelect extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-rom-size-trigger]');
        this.panel = this.querySelector('[data-rom-size-panel]');
        this.current = this.querySelector('[data-rom-size-current]');
        if (!this.trigger || !this.panel) return;

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onPanelChange = this.onPanelChange.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        this.trigger.addEventListener('click', this.onTriggerClick);
        this.panel.addEventListener('change', this.onPanelChange);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKeyDown);
      }

      get isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      onTriggerClick() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKeyDown);
        const checked = this.panel.querySelector('input[type="radio"]:checked:not(:disabled)');
        const first = this.panel.querySelector('input[type="radio"]:not(:disabled)');
        const target = checked || first;
        if (target) target.focus();
      }

      close() {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKeyDown);
      }

      onPanelChange(event) {
        const input = event.target;
        if (!input || input.type !== 'radio') return;
        if (this.current) {
          const label = this.querySelector('label[for="' + input.id + '"]');
          const size = label && label.querySelector('.rom-size-select__size');
          const equiv = label && label.querySelector('.rom-size-select__equiv');
          const sizeText = size ? size.textContent.trim() : '';
          const equivText = equiv ? equiv.textContent.trim() : '';
          if (sizeText) {
            this.current.textContent = '';
            const sizeEl = document.createElement('span');
            sizeEl.className = 'rom-size-select__current-size';
            sizeEl.textContent = sizeText;
            this.current.appendChild(sizeEl);
            if (equivText) {
              const equivEl = document.createElement('span');
              equivEl.className = 'rom-size-select__current-equiv';
              equivEl.textContent = equivText;
              this.current.appendChild(equivEl);
            }
          }
        }
        this.close();
      }

      onDocClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeyDown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          this.close();
          this.trigger.focus();
        }
      }
    }
  );
}
